@if (viewAll && translationEntries.length>0) {
  @if (hisobject[attributeName]?.length>0) {
    <div>
      <span hisImage="COMMENT_{{hisObjectLanguage.iso_639_1}}" title="{{(hisAttribute | hisUi) + ' ' + (hisObjectLanguageI18nKey |hisUi)}}"></span>
      <span style="padding:4px;" class="wordBreak" lang="{{hisObjectLanguage.iso_639_1}}">{{hisobject[attributeName]}}</span>
      <div class="clearerSpaceAboveHalfEm"></div>
    </div>
  }
  @for (entry of translationEntries; track entry; let i = $index) {
    <div >
      <span hisImage="COMMENT_{{entry[0]}}" title="{{('cs.sys.hisng.translationLabel_' + entry[0]) | hisUi: (hisAttribute | hisUi)}}"></span>
      <span style="padding:4px;" class="wordBreak" lang="{{entry[0]}}">{{entry[1]}}</span>
      @if (i<translationEntries.length-1) {
        <div class="clearerSpaceAboveHalfEm"></div>
      }
    </div>
  }
} @else {
  <span class="wordBreak" lang="{{language}}">{{translatedText}}</span>
}

